import { TaskCategoryOptions } from "../gateways/cms/task";
import { SelectFilter } from "./SelectFilter";

const options = TaskCategoryOptions.map(({ id, name }) => ({ value: String(id), label: name }));

export interface Props {
    value: string[];
    onChange: (value: string[]) => unknown;
}

export function SelectTaskCategoryFilter({ value, onChange }: Props) {
    return <SelectFilter options={options} value={value} onChange={onChange} />;
}
